import { ChangeEvent, FC } from 'react';

import { Box, InputBase, InputLabel } from '@mui/material';

import { CoverMessageInputProps } from '../types';

const CoverMessageInput: FC<CoverMessageInputProps> = ({
    defaultValue,
    setCoverMessage,
    placeholder = 'Enter your message...',
    disabled = false,
    minRows = 4,
    label = 'Cover Message',
}: CoverMessageInputProps) => {

    const handleOnChange = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setCoverMessage(event.target.value);
    };

    return (
        <Box sx={{ width: '100%', position: 'relative' }}>
            <InputLabel
                sx={{
                    position: 'absolute',
                    top: '-9px',
                    left: '12px',
                    backgroundColor: '#fff',
                    padding: '0 4px',
                    fontSize: '10px',
                    zIndex: 10,
                }}
            >
                {label}
            </InputLabel>
            <InputBase
                sx={{
                    '&.MuiInputBase-root': {
                        border: '1px solid #F39E4E',
                        borderRadius: '4px',
                        padding: '8px 12px',
                        width: '100%',
                        '&:hover': {
                            borderColor: '#F39E4E',
                            borderWidth: '1px',
                        },
                        '&.Mui-focused': {
                            borderColor: '#F39E4E',
                            borderWidth: '1px',
                            outline: 'none',
                        },
                        '&.Mui-disabled': {
                            borderColor: '#cccccc',
                            backgroundColor: '#f5f5f5',
                        },
                        '& textarea': {
                            resize: 'vertical',
                            overflow: 'auto',
                            maxHeight: '100px',
                        },
                    },
                }}
                placeholder={placeholder}
                value={defaultValue}
                onChange={handleOnChange}
                multiline
                minRows={minRows}
                disabled={disabled}
                inputProps={{ 'data-testid': 'text-area-test' }}
            />
        </Box>
    );
};

export default CoverMessageInput;
